import { Pipe, PipeTransform } from '@angular/core';

import DOMPurify from 'dompurify';

@Pipe({
  name: 'plainText',
  standalone: false,
})
export class PlainTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const withoutMarkup = DOMPurify.sanitize(value, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    });

    // DOMPurify returns escaped HTML; decode it so entities are not shown literally.
    const decoder = document.createElement('textarea');
    decoder.innerHTML = withoutMarkup;

    return decoder.value.replace(/\s+/g, ' ').trim();
  }
}
